export default __webpack_public_path__ + "static/media/Dual Ball-1s-200px.355d0dbd.svg";